Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var components_baseShape_component = require('../base-shape/component.js');
var components_superEllipse_paths = require('./paths.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var SuperEllipse = React.forwardRef(function (props, ref) { return (React__default.default.createElement(components_baseShape_component.BaseShape, tslib.__assign({}, props, { pathsMap: components_superEllipse_paths.pathsMap, ref: ref }))); });
SuperEllipse.displayName = 'SuperEllipse';

exports.SuperEllipse = SuperEllipse;
